class PriceCalculationService {
    /**
     * Calculate all package type prices for an arrangement
     * @param {Object} arrangement
     * @returns {Object}
     */
    calculatePackagePrices(arrangement) {
        const selectedTicketPrice = arrangement.price.ticket,
         hotelPrice = arrangement.price.hotel * arrangement.datesIntervalum,
         flightPrice = arrangement.price.flight || 0,
         discount = arrangement.price.discount || 0;

        return {
            'flight': selectedTicketPrice + flightPrice + hotelPrice - discount,
            'hotel' : selectedTicketPrice + hotelPrice - discount,
            'ticket': selectedTicketPrice - discount
        };
    }
}

export default new PriceCalculationService();